import {UPDATE_QUESTIONS_ERROR, UPDATE_QUESTIONS_START, UPDATE_QUESTIONS_SUCCESS} from "../../types";

export default function update_questions(state, action) {
    switch (action.type) {
        case UPDATE_QUESTIONS_START:
            return {
                ...state,
                loading: true,
                error: null
            };
        case UPDATE_QUESTIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };
        case UPDATE_QUESTIONS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.detail
            };
        default:
            return {...state};
    }
}
